import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';


@Injectable({
  providedIn: 'root'
})
export class CalendarAuthService {

  constructor(protected oauthService: OAuthService) {

  }

  async init(config: AuthConfig) {
    this.oauthService.configure(config);
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  async signIn() {
    this.oauthService.initImplicitFlow();
  }

  async signOut() {
    this.oauthService.logOut();
  }

  getAccessToken() {
    return this.oauthService.getAccessToken();
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
